import { TrendingUp, Zap, Star, Settings, Shield, Clock, Smile } from "lucide-react";

const benefits = [
  {
    icon: TrendingUp,
    title: "Vendas Ampliadas",
    description: "Destaque promoções com visuais de impacto, influenciando a decisão de compra no ponto de venda.",
    gradient: "from-green-500/20 to-green-500/5"
  },
  {
    icon: Zap,
    title: "Comunicação Ágil",
    description: "Divulgue novidades e altere preços instantaneamente, sem custos de impressão.",
    gradient: "from-blue-500/20 to-blue-500/5"
  },
  {
    icon: Star,
    title: "Experiência Elevada",
    description: "Modernize sua loja, reduza a percepção de espera e entretenha seu público.",
    gradient: "from-amber-500/20 to-amber-500/5"
  },
  {
    icon: Settings,
    title: "Operação Eficiente",
    description: "Centralize a gestão da sua comunicação, economize tempo e reduza custos operacionais.",
    gradient: "from-purple-500/20 to-purple-500/5"
  }
];

export const LandingBenefits = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `radial-gradient(circle at 1px 1px, #000 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} />

      <div className="max-w-[1440px] mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-full mb-6">
            <Zap className="w-4 h-4 text-primary" />
            <span className="text-sm font-bold text-gray-700 uppercase tracking-wide">Benefícios Reais</span>
          </div>
          <h2 className="text-4xl lg:text-6xl font-black tracking-tight text-gray-900 mb-6">
            Transforme Suas Telas em <span className="text-primary">Ativos Estratégicos</span>
          </h2>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group relative p-8 bg-white rounded-[32px] border border-gray-100 hover:border-gray-200 hover:shadow-2xl transition-all duration-500 overflow-hidden"
            >
              {/* Gradient Background on Hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${benefit.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />

              <div className="relative z-10 h-full flex flex-col">
                <div className="w-14 h-14 bg-gray-900 rounded-2xl flex items-center justify-center mb-6 text-primary group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg">
                  <benefit.icon className="w-7 h-7" />
                </div>
                <h3 className="text-xl font-black text-gray-900 mb-3 tracking-tight">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed font-medium">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-20 pt-12 border-t border-gray-100">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-16">
            {[
              { icon: Shield, label: "100% Seguro", value: "SSL Certificado" },
              { icon: Clock, label: "Uptime", value: "99.9%" },
              { icon: TrendingUp, label: "ROI Médio", value: "+240%" },
              { icon: Smile, label: "Satisfação", value: "4.9★" }
            ].map((stat, idx) => (
              <div key={idx} className="text-center group">
                <div className="w-12 h-12 mx-auto mb-4 bg-gray-100 rounded-xl flex items-center justify-center text-gray-600 group-hover:bg-primary group-hover:text-white transition-all">
                  <stat.icon className="w-6 h-6" />
                </div>
                <div className="text-2xl lg:text-3xl font-black text-gray-900 mb-1">{stat.value}</div>
                <div className="text-sm text-gray-500 font-bold uppercase tracking-wide">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
